/* eslint-disable max-len */
import * as React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import crypto from 'crypto';
import { analytics } from 'common/utils';
import _ from 'lodash';

import { Responsive } from 'common/components';
import { Header, RabbiCredit, Button, MakoAnalytics } from 'client/components/common';
import mainImg from 'assets/client/imgs/site-logo.svg';
import Banner from 'client/components/common/Banner';
import mainBgD from 'assets/client/imgs/main-bg-d.png';
import mainBgM from 'assets/client/imgs/main-bg-m.png';
import { CATEGORY_ROUTE } from 'client/constants';
import * as css from './MainPage.scss';

export default class MainPage extends React.PureComponent {
	static propTypes = {
		className: PropTypes.string,
		history: PropTypes.shape({
			push: PropTypes.func.isRequired,
		}).isRequired,
		isStarted: PropTypes.bool.isRequired,
		in: PropTypes.bool.isRequired,
		categories: PropTypes.shape({}),
	};

	static defaultProps = {
		className: '',
		categories: {},
	};

	state = {
		animationState: '',
	};

	onStartButtonClick = () => {
		const { history, categories } = this.props;
		const category = _.find(categories, ['order', 0]);
		const userId = window.localStorage.getItem('__uid__v2');

		analytics.gtag.event('להצבעה');

		if (!userId) {
			window.localStorage.setItem('__uid__v2', crypto.randomBytes(16).toString('hex'));
		}

		history.push(CATEGORY_ROUTE.replace(':categoryId', category.id));
	};

	animate = (node, done) => {
		if (this.props.in) {
			this.setState({ animationState: 'in' });
			setTimeout(done, parseInt(css.animationInTime, 10));
		} else {
			this.setState({ animationState: 'out' });
			setTimeout(done, parseInt(css.animationOutTime, 10));
		}
	};

	render() {
		const { className, isStarted } = this.props;
		const { animationState } = this.state;
		const cssTProps = _.omit(this.props, ['className', 'isStarted', 'staticContext', 'history']);
		const isMobile = Responsive.isMatching(Responsive.MOBILE);

		const buttonLabel = 'להצבעה >>';

		return (
			<CSSTransition {...cssTProps} addEndListener={this.animate}>
				<div className={classNames(css.mainPage, isStarted && css[animationState], className)}>
					{isMobile && <Banner />}
					<Responsive query={Responsive.DESKTOP}>
						<img src={mainBgD} alt="" className={css.mainBg} />
					</Responsive>
					<Responsive query={Responsive.MOBILE}>
						<img src={mainBgM} alt="" className={css.mainBg} />
					</Responsive>
					<Header className={css.header} isHiddenOnMain />

					<div className={css.content}>
						<img src={mainImg} alt="main" className={css.mainImg} />
						<h1 className={css.title}>
							הצביעו עכשיו למצעד הבינלאומי השנתי של גלגלצ ו-V1 ואולי תזכו בטיסה, מלון וזוג כרטיסים להופעה
							של אריאנה גרנדה בלונדון מתנת Live Events!
						</h1>
						<Button
							label={buttonLabel}
							type="primary"
							className={css.button}
							absoluteInner
							onClick={this.onStartButtonClick}
						/>
					</div>

					<MakoAnalytics vcmId="HP" />
					<RabbiCredit className={css.rabbiCredit} theme="light" />
				</div>
			</CSSTransition>
		);
	}
}
